import React, { useState } from 'react'
import {
  Container,
  TextTitle,
  TextBody,
  Icon64,
  Button,
  HtmlContent
} from '@pmi/pmi-iqos-ds-react'
import {
  htmlTranslation,
  ProfileNoDevice,
  AddDeviceForm
} from '@pmi/pmi-iqos-shared-react'

const AddDevice = ({
  translations,
  hasDevices,
  instructions,
  registrationParameters,
  emBlock,
  onAdd,
  defaultShowAddDevice,
  addDeviceSuccessBlock,
  showAddDeviceSuccess,
  line
}) => {
  const [showAddDevice, setShowAddDevice] = useState(defaultShowAddDevice)

  const handleAddDeviceConfirmation = async action => {
    await onAdd(action)
    setShowAddDevice(false)
  }

  const onAddDevice = () => {
    setShowAddDevice(true)
  }

  return (
    <Container>
      <Container bg={showAddDevice ? Container.backgrounds.hardWhite : null}>
        <Container divider={!showAddDevice ? Container.dividers.bottom : null}>
          <Container
            divider={
              !showAddDevice && hasDevices
                ? [null, null, Container.dividers.top]
                : null
            }>
            <Container px={['8', '8', '0']}>
              {showAddDevice ? (
                <AddDeviceForm
                  translations={translations}
                  instructions={instructions}
                  registrationParameters={registrationParameters}
                  onCancel={() => {
                    setShowAddDevice(false)
                  }}
                  onAdd={handleAddDeviceConfirmation}
                  emBlock={emBlock}
                  line={line}
                />
              ) : hasDevices ? (
                <Container
                  display={Container.displays.flex}
                  justifyContent={Container.justifyContentValues.between}
                  alignItems={Container.alignItemsValues.center}
                  flexDirection={[
                    Container.flexDirections.column,
                    Container.flexDirections.column,
                    Container.flexDirections.row
                  ]}
                  py="6">
                  <Container width={['full', 'full', '6/12']}>
                    <Container
                      display={Container.displays.flex}
                      flexDirection={Container.flexDirections.row}
                      alignItems={Container.alignItemsValues.center}
                      justifyContent={[
                        Container.justifyContentValues.center,
                        Container.justifyContentValues.center,
                        Container.justifyContentValues.start
                      ]}>
                      <Icon64
                        image={Icon64.images.myDevices}
                        size={Icon64.sizes.xl}
                      />
                      <Container pl="4">
                        <TextTitle heading={TextTitle.headings.h4}>
                          {translations.tk_registerDevice}
                        </TextTitle>
                      </Container>
                    </Container>
                    <Container pt="4">
                      <TextBody
                        alignment={[
                          TextBody.alignments.center,
                          TextBody.alignments.center,
                          TextBody.alignments.left
                        ]}
                        {...htmlTranslation(
                          translations,
                          'tk_registerDeviceDescription'
                        )}
                      />
                    </Container>
                  </Container>
                  <Container pt={['8', '8', '0']}>
                    <Button
                      onClickHandler={onAddDevice}
                      text={translations.tk_devicesAddDevice}
                      data-testing="Profile_Button_AddDevice"
                    />
                  </Container>
                </Container>
              ) : (
                <Container pb="20">
                  <ProfileNoDevice
                    translations={translations}
                    onAddDeviceClickHandler={onAddDevice}
                  />
                </Container>
              )}
            </Container>
          </Container>
        </Container>
      </Container>
      {showAddDeviceSuccess && addDeviceSuccessBlock && !showAddDevice && (
        <Container pt="8" px={['8', '8', '0']}>
          <HtmlContent content={addDeviceSuccessBlock} />
        </Container>
      )}
    </Container>
  )
}

export default AddDevice
